import { render, staticRenderFns } from "./LocalizedTextColumn.vue?vue&type=template&id=86806200&scoped=true&"
import script from "./LocalizedTextColumn.vue?vue&type=script&lang=ts&"
export * from "./LocalizedTextColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86806200",
  null
  
)

export default component.exports